export default "__VITE_ASSET__CVbcfHjJ__"